/* eslint-disable camelcase */
import { createSelector } from 'reselect';

// Maps a route section to the team scope required to access it.
// Catalog is intentionally not handled here: that section does not exist in this app.
export const SECTION_SCOPES = {
  analytics: 'analytics:read',
  billing: 'bill:read',
  catalog: 'catalog:read',
};

// Returns the gated section for a given pathname, or null if the route is not gated.
export function getRequiredSection(pathname = '') {
  if (pathname.startsWith('/analytics')) return 'analytics';
  if (pathname.startsWith('/billing')) return 'billing';

  return null;
}

const selectTeams = createSelector(
  (state) => state.teams,
  (teams) => {
    const { payload, loaded, error } = teams || {};
    const { user_role: userRole, user_scopes: userScopes } = payload || {};

    const scopes = Array.isArray(userScopes) ? userScopes : [];
    const isOwner = userRole === 'owner';

    // Fail-open: while loading, on error, or for owners, grant access to everything.
    const allowAll = !loaded || !!error || isOwner;

    const hasScope = (scope) => allowAll || scopes.includes(scope);

    const canAccessSection = (section) => {
      const required = SECTION_SCOPES[section];

      if (!required) return true;

      return hasScope(required);
    };

    return {
      userRole,
      userScopes: scopes,
      isOwner,
      loaded: !!loaded,
      hasScope,
      canAccessSection,
      canAccessAnalytics: canAccessSection('analytics'),
      canAccessBilling: canAccessSection('billing'),
    };
  },
);

export default selectTeams;
